import COLOR from "../../../constants/colors";

const styles = {
  paleBackground: {
    background: COLOR.white,
  },
  greenBackground: {
    background: COLOR.green,
  },
  mainArea: {
    paddingTop: 16,
    marginLeft: 0,
    minWidth: "180vh",
    background: COLOR.greenSmoke,
  },
};

export default styles;
